import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import MembershipPresenter from '../../../../presenters/FastCash/MembershipPresenter';
import arrowDropUp from '../../../../assets/arrow-drop-up.svg';
import arrowDropDown from '../../../../assets/arrow-drop-down.svg';
import { VISIBILITY, SIZE } from '../../../../constants/styles';

import MembershipInfo from './components/MembershipInfo';
import Bonuses from './components/Bonuses';
import Payments from './components/Payments';
import Logs from './components/Logs';
import Header from './components/Header';

const Membership = (props) => {
  const {
    membership,
    membershipsVisibility,
    onMembershipVisibilityChange,
    onMembershipUpdate,
    onResponseUpdate,
  } = props;

  const paymentsAmount = MembershipPresenter.paymentsAmountReadable(membership);
  const bonusesAmount = MembershipPresenter.bonusesAmountReadable(membership);

  const membershipId = MembershipPresenter.id(membership);
  const currentMembershipVisibility = membershipsVisibility[membershipId];
  const isVisibleMembership =
    currentMembershipVisibility === VISIBILITY.visible;

  const [isPaymentsVisible, setIsPaymentsVisible] = useState(false);
  const [isBonusesVisible, setIsBonusesVisible] = useState(false);
  const [isLogsVisible, setIsLogsVisible] = useState(false);

  const handlePaymentsVisibilityChange = () =>
    setIsPaymentsVisible(!isPaymentsVisible);

  const handleBonusesVisibilityChange = () =>
    setIsBonusesVisible(!isBonusesVisible);

  const handleLogsVisibilityChange = () => setIsLogsVisible(!isLogsVisible);

  const renderArrow = (isVisible, size = SIZE.medium) => (
    <img
      className={size === SIZE.small ? 'small-arrow' : 'arrow'}
      alt={isVisible ? 'arrow-drop-up' : 'arrow-drop-down'}
      src={isVisible ? arrowDropUp : arrowDropDown}
    />
  );
  const paymentsDropdownTableHeaderArguments = {
    collectionName: 'Payments',
    handleVisibilityChange: handlePaymentsVisibilityChange,
    isVisible: isPaymentsVisible,
    amount: paymentsAmount,
  };
  const bonusesDropdownTableHeaderArguments = {
    collectionName: 'Bonuses',
    handleVisibilityChange: handleBonusesVisibilityChange,
    isVisible: isBonusesVisible,
    amount: bonusesAmount,
  };

  const logsDropdownTableHeaderArguments = {
    collectionName: 'Logs',
    handleVisibilityChange: handleLogsVisibilityChange,
    isVisible: isLogsVisible,
    amount: null,
  };

  const renderDropdownTableHeader = (props) => {
    const { collectionName, handleVisibilityChange, isVisible, amount } = props;

    return (
      <div className="membership-table-header">
        <button className="action-button" onClick={handleVisibilityChange}>
          {collectionName}
          {renderArrow(isVisible, SIZE.small)}
        </button>
        {!isNil(amount) && `(Total amount: ${amount})`}
      </div>
    );
  };

  return (
    <div className="membership">
      <Header
        onVisibilityChange={onMembershipVisibilityChange}
        membership={membership}
        renderArrow={renderArrow}
        onMembershipUpdate={onMembershipUpdate}
        isVisible={isVisibleMembership}
      />
      {isVisibleMembership && (
        <div>
          <MembershipInfo membership={membership} />
          {renderDropdownTableHeader(paymentsDropdownTableHeaderArguments)}
          {isPaymentsVisible && (
            <Payments
              membershipId={membershipId}
              onResponseUpdate={onResponseUpdate}
            />
          )}
          {renderDropdownTableHeader(bonusesDropdownTableHeaderArguments)}
          {isBonusesVisible && (
            <Bonuses
              membershipId={membershipId}
              onResponseUpdate={onResponseUpdate}
            />
          )}

          {renderDropdownTableHeader(logsDropdownTableHeaderArguments)}
          {isLogsVisible && <Logs membershipId={membershipId} />}
        </div>
      )}
    </div>
  );
};

export default Membership;

Membership.propTypes = {
  membership: MembershipPresenter.shape().isRequired,
  membershipsVisibility: PropTypes.object.isRequired,
  onMembershipVisibilityChange: PropTypes.func.isRequired,
  onMembershipUpdate: PropTypes.func.isRequired,
  onResponseUpdate: PropTypes.func.isRequired,
};
